import { forwardRef, type HTMLAttributes, type PropsWithChildren } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import css from './styles.module.scss';

const borderedWrapperVariants = cva('', {
  variants: {
    variant: {
      default: css['borderedWrapper--default'],
    },
    rounded: {
      '80': 'rounded-[80px]',
    },
  },
});

interface BorderedWrapperProps
  extends VariantProps<typeof borderedWrapperVariants>,
    PropsWithChildren,
    HTMLAttributes<HTMLDivElement> {}

const BorderedWrapper = forwardRef<HTMLDivElement, BorderedWrapperProps>(
  ({ variant = 'default', rounded = '80', children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(
          borderedWrapperVariants({ variant, rounded }),
          props.className,
        )}
      >
        {children}
      </div>
    );
  },
);

export { BorderedWrapper };
